<template>
  <lida-table
    :propscolumns="columns"
    :data="gametotalItems"
    :sortStatus="false"
    align="right"
    :SpinLoading="loading"
    :propsPageSize="50"
    :LeaveSpace="false"
  >
    <template v-slot:headerSelect>
      <p class="title text-left">{{title}}</p>
    </template>
  </lida-table>
</template>
<script>
import { mapGetters } from 'vuex'
import NP from 'number-precision'
import { ToDecimal } from 'utils';
import switchHie from '@/views/ledger/mixins/switchHie'
import reportCount from '@/mixins/report-count.js'
import acountData from '@/mixins/acount-data'
export default {
  name: 'report-frist-tatal',
  mixins: [reportCount, switchHie, acountData],
  props: {
    objectdata: {
      type: Object,
    },
    title: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    stid: {
      type: [String, Number]
    }
  },
  data () {
    return {
      gametotalItems: [],
      notSunArray: ['gameid', 'buid', 'name', 'pmid', 'l1tlpa', 'l1total'],
    }
  },
  computed: {
    ...mapGetters(['lidaTableCheck']),
    columns () {
      const object = {
        indexNumber: {
          title: '序号',
          align: 'center',
          key: 'indexNumber',
          width: 40
        },
        gameid: {
          title: '游戏项目',
          align: 'center',
          key: 'gameid',
          width: 120,
          totaltext: '总计',
          render: (h, params) => {
            if (params.row.gameid == '总计') return h('p', params.row.gameid)
            const gameid = params.row.gameid || this.query.gameid
            const list = this.getalllist.find(it => it.gameid == gameid)
            return this.stidlistLengthStatus
              ? h('a', {
                  on: {
                    click: () => {
                      let query = {
                        ...this.$route.query,
                        stidlist: this.stid,
                        gmclist: params.row.gameid
                      }
                      this.$router.push({
                        name: 'assort-ledger-report1',
                        query
                      })
                    }
                  }
                }, list.gamename)
              : h('p', list.gamename)
          },
        },
        cou: {
          title: '注数',
          align: 'center',
          key: 'cou',
          width: 50,
          total: true,
          render: (h, params) => h('span', this.$commaFormat(params.row.cou))
        },
        sumval: {
          title: '下注金额',
          align: 'center',
          key: 'sumval',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'sumval')
        },
        effval: {
          title: '有效额',
          align: 'center',
          key: 'effval',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          minWidth: 20,
          render: (h, params) => {
            const value = params.row.effval * -1
            return h('p', this.NegativeColor(value), this.toDecimal2(value))
          }
        },
        payds: {
          title: '会员佣金',
          align: 'center',
          key: 'payds',
          className: 'trigger-show ',
          triggerShow: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'payds')
        },
        pal: {
          title: '会员盈亏',
          align: 'center',
          key: 'pal',
          total: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'pal')
        },
        lupps: {
          title: `${this.levelName[1]}占成上缴`,
          align: 'center',
          key: 'lupps',
          total: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'lupps')
        },
        l1total: {
          title: `${this.levelName[1]}上缴%`,
          align: 'center',
          key: 'l1total',
          render: (h, params) => {
            if (params.row.gameid !== '总计') {
              const l1total = params.row.l1total
              return !this.checkFooterText(params.row.gameid) ? h('p', `${params.row.l1tl > 0 ? ((params.row.l1tl / l1total) * 100).toFixed(2) : 0}%`) : null
            }
          },
        },
        lupt: {
          title: `${this.levelName[1]}上缴`,
          align: 'center',
          key: 'lupt',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'lupt')
        },
        odddiffval1: {
          title: `${this.levelName[1]}差价数`,
          align: 'center',
          key: 'odddiffval1',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'odddiffval1')
        },
        l1tltotal: {
          title: `${this.levelName[0]}占成(%)`,
          align: 'center',
          key: 'l2p',
          render: (h, params) => {
            const value = params.row.effval != 0 ? ((params.row.l1tl / params.row.effval) * 100).toFixed(2) : 0
            return !this.checkFooterText(params.row.gameid) ? h('span', `${value}%`) : null
          },
        },
        l1tl: {
          title: `${this.levelName[0]}占成`,
          align: 'center',
          key: 'l1tl',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l1tl')
        },
        kekka: {
          title: `${this.levelName[0]}占成盈亏`,
          align: 'center',
          key: 'kekka',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'kekka')
        },
        l1pds: {
          title: `${this.levelName[0]}赚佣`,
          align: 'center',
          key: 'l1pds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l1pds')
        },
        Cbonus: {
          title: `${this.levelName[0]}补货奖金`,
          align: 'center',
          key: 'Cbonus',
          total: true,
          render: (h, params) => h('p', params.row.Cbonus)
        },
        bupayds: {
          title: `${this.levelName[0]}补货佣金`,
          align: 'center',
          key: 'bupayds',
          total: true,
          render: (h, params) => h('p', params.row.bupayds)
        },
        cpal: {
          title: `${this.levelName[0]}盈亏`,
          align: 'center',
          key: 'cpal',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'cpal')
        },
      }
      return object
    },
    levelName () {
      let levelArray = this.acountData.map(item => item.name)
      return levelArray
    }
  },
  watch: {
    objectdata: {
      immediate: true,
      handler (val) {
        this.sunGameTotal(val)
      }
    }
  },
  methods: {
    sunGameTotal ({ l1totalAll, data }) { // 总计table
      if (!Object.keys(this.objectdata).length) return
      const array = Object.keys(data).reduce((acc, val) => {
        acc[val] = data[val].reduce((acc2, val2) => {
          const keys = Object.keys(val2)
          keys.forEach(it => {
            if (it in acc2 == false) acc2[it] = 0
            if (this.some(this.notSunArray, it)) {
              acc2[it] = NP.plus(parseFloat(acc2[it]).toFixed(4), parseFloat(val2[it]).toFixed(4))
            } else {
              acc2[it] = val2[it]
            }
            acc2.l1total = l1totalAll
          });
          return acc2
        }, {})
        return acc
      }, {})
      this.gametotalItems = Object.values(array)
    },
  }
}
</script>